import { V } from "../../app/pages.js";
import { S } from "../../app/store.js";
import { esc } from "../../domain/format.js";
import { uname } from "../../services/access.js";

export const auditTable = () => `<section class="panel"><h2>Audit trail</h2><p class="small muted">Append-only. No role can edit or delete entries.</p><div class="tbl"><table><thead><tr><th>When (Manila)</th><th>User</th><th>Action</th><th>Detail</th></tr></thead><tbody>
 ${S.audit
   .slice()
   .reverse()
   .map(
     (a) =>
       `<tr><td class="small num" style="text-align:left">${new Date(a.t).toLocaleString("en-PH", { timeZone: "Asia/Manila", dateStyle: "medium", timeStyle: "short" })}</td><td>${esc(uname(a.u))}</td><td>${esc(a.a)}</td><td>${esc(a.d)}</td></tr>`,
   )
   .join("")}</tbody></table></div></section>`;
V.audit = auditTable;
